import { useLocation } from 'react-router-dom';
import { INPSQueryParams } from '@whitelabel/helpers/types';
import {
  SOURCE_EMAIL,
  SOURCE_SMS,
  NPS_SMS_MODAL_PARAMS,
  NPS_EMAIL_MODAL_PARAMS,
} from '@whitelabel/xcover-shared/helpers/constants';

export const useNPSQueryParams = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  if (queryParams.get(NPS_EMAIL_MODAL_PARAMS.NPS_SOURCE) === SOURCE_EMAIL) {
    return {
      npsSource: queryParams.get(NPS_EMAIL_MODAL_PARAMS.NPS_SOURCE),
      source: queryParams.get(NPS_EMAIL_MODAL_PARAMS.SOURCE),
      bookingID: queryParams.get(NPS_EMAIL_MODAL_PARAMS.BOOKING_ID),
      score: queryParams.get(NPS_EMAIL_MODAL_PARAMS.SCORE),
    } as INPSQueryParams;
  }

  if (queryParams.get(NPS_SMS_MODAL_PARAMS.NPS_SOURCE) === SOURCE_SMS) {
    return {
      npsSource: queryParams.get(NPS_SMS_MODAL_PARAMS.NPS_SOURCE),
      source: queryParams.get(NPS_SMS_MODAL_PARAMS.SOURCE),
      bookingID: queryParams.get(NPS_SMS_MODAL_PARAMS.BOOKING_ID),
    } as INPSQueryParams;
  }

  return undefined;
};
